const c = {
  name: "MlPaymentOptimizationAndExperimentation",
  dimensions: { width: 40, height: 36 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 36" style="enable-background:new 0 0 40 36;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M34,3c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3C35.3,6,34,4.7,34,3z M37,2c-0.6,0-1,0.4-1,1
			c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1C38,2.4,37.6,2,37,2z"/>
		<path class="st0" d="M25.2,7H5c-2.8,0-5,2.2-5,5v12c0,2.8,2.2,5,5,5h20.2c0.4,1.2,1.5,2,2.8,2c1.7,0,3-1.3,3-3c0-1.7-1.3-3-3-3
			c-1.3,0-2.4,0.8-2.8,2H5c-1.7,0-3-1.3-3-3V12c0-1.7,1.3-3,3-3h20.2c0.4,1.2,1.5,2,2.8,2c0.8,0,1.5-0.3,2-0.8l4.1,2.3
			c0,0.2,0,0.3,0,0.5c0,0.2,0,0.3,0,0.5L30,15.8c-0.5-0.5-1.2-0.8-2-0.8c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3c0.8,0,1.5-0.3,2-0.8
			l4.1,2.3c0,0.2,0,0.3,0,0.5c0,1.3,0.8,2.4,2,2.8v4.3c-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3c0-1.3-0.8-2.4-2-2.8
			v-4.3c1.2-0.4,2-1.5,2-2.8c0-1.7-1.3-3-3-3c-0.8,0-1.5,0.3-2,0.8L31,18.5c0-0.2,0-0.3,0-0.5c0-0.2,0-0.3,0-0.5l4.1-2.3
			c0.5,0.5,1.2,0.8,2,0.8c1.7,0,3-1.3,3-3c0-1.7-1.3-3-3-3c-0.8,0-1.5,0.3-2,0.8L31,8.5c0-0.2,0-0.3,0-0.5c0-1.7-1.3-3-3-3
			C26.7,5,25.6,5.8,25.2,7z M27,8c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1S27,8.6,27,8z M27,28c0-0.6,0.4-1,1-1s1,0.4,1,1
			s-0.4,1-1,1S27,28.6,27,28z M28,17c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S27.4,17,28,17z M36,13c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1
			c0,0.6-0.4,1-1,1C36.4,14,36,13.6,36,13z M37,22c0.6,0,1,0.4,1,1s-0.4,1-1,1c-0.6,0-1-0.4-1-1S36.4,22,37,22z M36,33
			c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1s-0.4,1-1,1C36.4,34,36,33.6,36,33z"/>
		<path class="st0" d="M4,15h6v6H4V15z M6,17v2h2v-2H6z"/>
		<path class="st0" d="M4,25h16v-2H4V25z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as MlPaymentOptimizationAndExperimentation
};
